const dialogs = [
    [
        ['Co to tam je?', 'To je {WORD}']
    ],
    [
        ['Bez čeho nemůžeš žít?', 'Nemůžu žít bez {WORD}!'],
        ['Kde chceš žit?', 'Chtel bych žit kolem {WORD}!'],
        ['Kde je ta vec?', 'Ta vec léži kolem {WORD}!'],
    ],
    [
        ['Proč pláčeš?', 'Pláču kvůli {WORD} 😭'],
        ['Kde chceš žit?', 'Chtel bych žit naproti {WORD}!'],
        ['Kde je ta vec?', 'Ta vec léži naproti {WORD}!'],
    ],
    [
        ['K čemu to dělaš?', 'Dělám to pro {WORD}'],
        ['Kde chceš žit?', 'Chtel bych žit za {WORD}!'],
        ['Kde je ta vec?', 'Ta vec léži za {WORD}!'],
    ],
    [
        ['Jak správně volat?', '{WORD}!']
    ],
    [
        ['O čem mluvite?', 'Mluvíme o {WORD}.'],
        ['Kde chceš žit?', 'Chtel bych žit na {WORD}!'],
        ['Kde je ta vec?', 'Ta vec léži na {WORD}!'],
    ],
    [
        ['Jak ho vystrašim?', 'Vystrašim ho {WORD}'],
        ['Kde chceš žit?', 'Chtel bych žit před {WORD}!'],
        ['Kde je ta vec?', 'Ta vec léži před {WORD}!'],
    ],


    [
        ['Co to tam je?', 'To jsou {WORD}']
    ],
    [
        ['Bez čeho nemůžeš žít?', 'Nemůžu žít bez {WORD}!']
    ],
    [
        ['Proč pláčeš?', 'Pláču kvůli {WORD} 😭']
    ],
    [
        ['K čemu to dělaš?', 'Dělám to pro {WORD}']
    ],
    [
        ['Jak správně volat?', '{WORD}!']
    ],
    [
        ['O čem mluvite?', 'Mluvíme o {WORD}.']
    ],
    [
        ['Jak ho vystrašim?', 'Vystrašim ho {WORD}']
    ],
]

export default dialogs;